import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement(Svg //   xmlns="http://www.w3.org/2000/svg"
  , _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M7.783 2.579c-.895-1.058-2.607-1.377-3.688-.21-.631.682-1.276 1.57-1.615 2.586-.44 1.323-.182 2.953.7 4.764.889 1.824 2.452 3.924 4.785 6.257l1.06-1.06c-2.262-2.264-3.705-4.23-4.496-5.854-.797-1.635-.892-2.834-.626-3.632.247-.74.742-1.447 1.293-2.042.334-.36.992-.371 1.442.16l1.806 2.135c.336.396.391.96.139 1.414l-.536.964c-.475.854-.473 1.932.13 2.77a22.086 22.086 0 002.263 2.67l1.06-1.06a20.584 20.584 0 01-2.105-2.487c-.232-.322-.256-.769-.037-1.164l.536-.964a2.75 2.75 0 00-.305-3.112L7.783 2.579z",
    fill: "#000",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M21.362 16.158c1.058.895 1.377 2.607.21 3.688-.682.63-1.57 1.276-2.586 1.614-1.323.441-2.953.183-4.764-.7-1.824-.888-3.924-2.45-6.257-4.784l1.06-1.06c2.263 2.262 4.23 3.705 5.853 4.496 1.636.796 2.835.891 3.633.625.74-.246 1.447-.741 2.042-1.292.36-.334.371-.992-.16-1.442l-2.135-1.806a1.25 1.25 0 00-1.414-.139l-.964.536c-.855.474-1.932.473-2.77-.13a22.091 22.091 0 01-2.67-2.263l1.06-1.06a20.586 20.586 0 002.486 2.105c.323.232.77.256 1.165.037l.964-.536a2.75 2.75 0 013.112.304l2.135 1.807z",
    fill: "#000",
    fillOpacity: 0.65
  }));
}
export default SvgComponent;